var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"issue-select-table-cell",on:{"click":function($event){$event.stopPropagation();}}},[_c('v-simple-checkbox',{attrs:{"value":_vm.isSelected,"ripple":false,"color":"primary","dense":""},on:{"input":function($event){return _vm.$emit('toggleSelect', _vm.item)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }